import React from 'react';
import '../styles/footer.scss';
import { Container, Col, Row } from 'react-bootstrap';

export default function Footer() {
    return (
        <Container fluid className="footer" aria-label="Footer">
            <footer>
                <Row>
                    <Col xs={12} md={3} >
                        <a href="http://www1.nyc.gov/nyc-resources/agencies.page">Directory of City Agencies</a><br />
                        <a href="http://www1.nyc.gov/notifynyc">Notify NYC</a><br />
                        <a href="http://www1.nyc.gov/connect/applications.page">NYC Mobile Apps</a><br />
                    </Col >
                    <Col xs={12} md={3}>
                        <a href="http://www1.nyc.gov/home/contact-us.page">Contact NYC Government</a><br />
                        <a href="http://a856-citystore.nyc.gov/">CityStore</a><br />
                        <a href="http://www1.nyc.gov/nyc-resources/nyc-maps.page">Maps </a><br />
                    </Col >
                    <Col xs={12} md={3}>
                        <a href="https://a127-ess.nyc.gov">City Employees</a><br />
                        <a href="http://www1.nyc.gov/connect/social-media.page">Stay Connected</a><br />
                        <a href="http://www1.nyc.gov/nyc-resources/resident-toolkit.page">Resident Toolkit</a><br /><br />

                    </Col >
                    <Col xs={12} md={3}>
                        <img className="img-responsive" src="http://www.nyc.gov/html/innovativegovernment/html/img/nyc.png" alt="Official NYC logo white text on black background" role="presentation" /><br /><br />
                        <p>City of New York. 2020 All Rights Reserved, NYC is a trademark and service mark of the City of New York.</p>
                        <p><a href="http://www1.nyc.gov/home/privacy-policy.page" title="NYC Privacy Policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
                        <a href="http://www1.nyc.gov/home/terms-of-use.page" title="NYC terms of use" target="_blank" rel="noopener noreferrer">Terms of Use</a>.</p>
                    </Col >
                </Row>
            </footer >
        </Container >
    )
}
